import { takeLatest } from 'redux-saga'
import { call, put } from 'redux-saga/effects'

import PipelineDeals from 'PipelineDeals'

import { updateAccount } from 'ducks'
import { SET_LANGUAGE } from 'i18n/reducer'

// Generic action other reducers can subscribe to for clearing translated derivations.
export const LOCALE_INVALIDATE_CACHES = 'LOCALE_INVALIDATE_CACHES'

const accountPd = new PipelineDeals({ exclude_attrs: 'total_company_count' }, '/api/v3')

// On runtime locale change, refetch the account so translated content baked into
// the account JSON (custom field group names, conditional_fields_defaults, etc.)
// reloads from the backend under the new locale.
export function * onLocaleChangeSaga () {
  try {
    const account = yield call([accountPd, accountPd.account])
    const currentAccount = yield call([account, account.get])
    yield put(updateAccount(currentAccount))
    yield put({ type: LOCALE_INVALIDATE_CACHES })
  } catch (e) {
    console.error('locale change saga failed', e)
  }
}

// takeLatest (not takeEvery): rapid language toggles should cancel any in-flight
// account refetch so the last requested locale always wins, regardless of which
// network response returns first.
export function * watchOnLocaleChangeSaga () {
  yield call(takeLatest, SET_LANGUAGE, onLocaleChangeSaga)
}
